import {
    useDeleteCvV2ApplyMutation,
    useLazyGetApplyV2SocketQuery,
    usePostCvV2ApplyMutation,
} from '@core/app/api/applyJobV2Api'
import type { ApplyV2TempBase64File, ApplyV2TempProfileCvData } from '@core/app/types/applyV2Type'
import { InfoIcon } from '@core/assets/icons/info_icon'
import ApplyV2AttachmentsUploader from '@core/components/ApplyDialogV2/ApplyV2AttachmentsUploader'
import ApplyV2Button from '@core/components/ApplyDialogV2/ApplyV2Button'
import ApplyV2InputRadio from '@core/components/ApplyDialogV2/ApplyV2InputRadio'
import UploadCvIcon from '@core/components/ApplyDialogV2/assets/UploadCvIcon'
import DefaultMaskIcon from '@core/components/ApplyDialogV2/FileUploaderV2/DefaultMaskIcon'
import UnsupportedFileMaskIcon from '@core/components/ApplyDialogV2/FileUploaderV2/UnsupportedFileMaskIcon'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import getAcceptFilesString from '@core/utils/helpers/getAcceptFilesString'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import React, { useEffect, useRef, useState } from 'react'
import './ApplyV2CvStep2.scss'

const baseClass = 'ApplyV2CvStep2'

function ApplyV2CvStep2() {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        isFinalStep,
        setIsFinalStep,
        isPostApplied,
        onCloseApply,
        settingsData,
        navItems,
        onNextStep,
        postProfileRefetch,
        sendWebSocketMessage,
        cvParserStatus,
        isWebSocketConnected,
    } = useApplyV2Context()
    const { getTitle } = useApplyV2NavTranslations()
    const [files, setFiles] = useState<(ApplyV2TempBase64File | ApplyV2TempProfileCvData)[]>([])
    const [radio, setRadio] = useState<boolean>(true)
    const [postCvRequest, { isLoading: isCvLoading, error: cvError }] = usePostCvV2ApplyMutation()
    const [deleteCvRequest, { isLoading: isCvDeleteLoading, isError: isDeleteError }] = useDeleteCvV2ApplyMutation()
    // const [trigger, { data, isFetching, isLoading, isError }] = useLazyGetApplyV2SocketQuery()
    const wsRef = useRef<WebSocket | null>(null)
    const [progress, setProgress] = useState(0)
    const [cvStateError, setCvStateError] = useState<string | null>(null)

    // const existingCv = postProfileData?.data?.cv || null

    const isCvRequired = settingsData?.steps?.cv?.required && settingsData?.steps?.cv?.visible
    //
    const isShowInput = !(files.length || isCvLoading || isCvDeleteLoading)

    console.log(!files.length, !isCvLoading, !isCvDeleteLoading, isShowInput)

    useEffect(() => {
        let timeout: NodeJS.Timeout | null = null

        const tick = (delay: number) => {
            timeout = setTimeout(() => {
                setProgress((prev) => {
                    if (prev >= 98) return prev

                    let step = 5
                    if (prev >= 90) step = 1

                    const next = prev + step
                    const nextDelay = next < 60 ? delay : delay * 2

                    tick(nextDelay)
                    return next
                })
            }, delay)
        }

        if (isCvLoading) {
            setProgress(0)
            tick(300)
        } else {
            setProgress(100)
        }

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [isCvLoading])

    const handleNext = async () => {
        if (radio) {
            sendWebSocketMessage('subscribe')
            sendWebSocketMessage('cv-parser')
        }
        onNextStep()
    }

    const deleteCvHandler = async () => {
        try {
            const res = await deleteCvRequest({
                uid: postProfileData?.data?.uid ?? '',
            }).unwrap()
            setFiles([])
            console.log('Delete res', res)
        } catch (e) {}
    }

    const uploadCvHandler = async (cvs: ApplyV2TempBase64File[]) => {
        const cv = cvs[0]
        const uid = postProfileData?.data?.uid

        if (!cv || !uid || !('base64' in cv)) {
            console.log('No Cv or Uid')
            return
        }
        try {
            setFiles(cvs)
            const res = await postCvRequest({
                uid: uid,
                body: {
                    cv: {
                        name: cv.name,
                        ext: cv.ext,
                        base64: cv.base64,
                    },
                },
            }).unwrap()
            // .then((res) => {
            //     console.log('CV res ', res)
            // })
            // .catch((e) => {
            //     console.log('Error uploading file', e)
            // })
            console.log('FFF', res)
        } catch (e: any) {
            setCvStateError(e.message)
            console.log('ERROR', e)
        } finally {
        }
    }

    console.log('Is isWebSocketConnected', isWebSocketConnected, cvParserStatus)

    useEffect(() => {
        if (postProfileData?.data?.cv) {
            setFiles([postProfileData.data.cv])
        } else {
            setFiles([])
        }
    }, [postProfileData?.data?.cv])

    const filesErrors = files
        .map((f) => {
            return { ...f, error: 'errFF' }
        })
        .filter((f) => cvStateError)

    return (
        <div className={baseClass}>
            <ApplyV2AttachmentsUploader
                maxFileSize={10}
                accept={getAcceptFilesString('CV')}
                files={files}
                onChange={uploadCvHandler}
                multipleCount={1}
                progressItems={isCvLoading ? [{ index: 0, progress }] : []}
                onDelete={deleteCvHandler}
                // errorMessage={'ddd'}
                isShowInput={isShowInput}
                filesErrors={filesErrors}
                loadingIds={
                    isCvDeleteLoading
                        ? files.map((f) => {
                              if ('uid' in f) {
                                  return f.uid
                              } else {
                                  return f.name
                              }
                          })
                        : []
                }
            >
                <UploadCvIcon className={`${baseClass}__icon`} />
                <p
                    className={`${baseClass}__inner__text`}
                    style={{
                        fontSize: '12px',
                        marginBottom: '2px',
                        marginTop: '8px',
                        fontWeight: 500,
                    }}
                >
                    {getTitle('10348', 'Drop files here or click to upload')}
                </p>
                <p
                    style={{
                        fontSize: '11px',
                        color: '#999',
                    }}
                >
                    PDF / DOC / DOCX
                </p>
            </ApplyV2AttachmentsUploader>

            {(!files.length || isCvLoading) && (
                <div className={`${baseClass}__info`}>
                    <span className={`${baseClass}__info-icon`}>
                        <InfoIcon />
                    </span>
                    <span>
                        {getTitle(
                            '10425',
                            'Information from your CV file can be automatically parsed to fill in the details in the following steps.'
                        )}
                    </span>
                </div>
            )}
            {!!files.length && !isCvLoading && (
                <div className={`${baseClass}__description`}>
                    <p className={`${baseClass}__description--title`}>
                        {getTitle('8799', 'Would you like to automatically parse your CV?')}
                    </p>
                    <p className={`${baseClass}__description--par`}>
                        {getTitle(
                            '10426',
                            'Information from you CV file can be automatically parsed to fill in the details in the following steps (your profile as well).'
                        )}
                    </p>
                    <p className={`${baseClass}__description--par`}>
                        {getTitle('10427', 'You will be able to add or edit any information at any time.')}
                    </p>
                    <ApplyV2InputRadio
                        className={`${baseClass}__description--radio`}
                        value={radio}
                        onChange={(f) => {
                            setRadio(!!f)
                        }}
                        options={[
                            { value: true, label: getTitle('128', 'Yes') },
                            { value: false, label: getTitle('8801', 'No, I’ll add information myself') },
                        ]}
                    />
                </div>
            )}
            <div className={`ApplyDialogV2__next ${baseClass}__next`}>
                {!settingsData?.steps?.cv?.required && (
                    <ApplyV2Button
                        variant={'transparent'}
                        className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-skip`}
                        rightIcon={'>'}
                        // isDisabled={isValidateLoading || !formik.isValid}
                        onClick={() => {
                            onNextStep()
                        }}
                    >
                        {getTitle('6107', 'Skip')}
                    </ApplyV2Button>
                )}
                <ApplyV2Button
                    type="submit"
                    variant={'primary'}
                    className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-submit`}
                    isLoading={
                        isCvLoading ||
                        cvParserStatus === 'file-search-started' ||
                        cvParserStatus === 'file-sent-to-parsing' ||
                        cvParserStatus === 'in-progress'
                    }
                    isDisabled={isCvLoading || isCvLoading || (isCvRequired && files.length < 1)}
                    onClick={handleNext}
                >
                    {getTitle('3035', 'Next')}
                </ApplyV2Button>
            </div>
        </div>
    )
}

export default ApplyV2CvStep2
